<mat-card>
    <mat-card-content class="container-fluid">
        <h6>{{ 'ECMR.ecmr_editor.documents.title' | translate }}</h6>

        @if (!disabled) {
            <div
                class="upload-zone"
                appDragDrop
                (fileDropped)="onFilesDropped($event)"
                (click)="fileInput.click()">
                <input
                    type="file"
                    #fileInput
                    accept=".pdf,.png,.jpg,.jpeg"
                    (change)="onFileSelected($event)"
                    hidden />
                <mat-icon fontSet="material-symbols-outlined"
                    >cloud_upload</mat-icon
                >
                <p class="upload-text">
                    {{ 'ECMR.ecmr_editor.documents.drop_or_click' | translate }}
                </p>
                <p class="upload-hint">
                    {{ 'ECMR.ecmr_editor.documents.allowed_types' | translate }}
                </p>
            </div>
        }

        @if (uploading) {
            <mat-progress-bar
                mode="determinate"
                [value]="uploadProgress"
                class="mt-2">
            </mat-progress-bar>
        }

        @if (documents.length > 0) {
            <mat-list class="mt-2">
                @for (doc of documents; track doc.id) {
                    <mat-list-item>
                        <mat-icon matListItemIcon fontSet="material-symbols-outlined">
                            {{ getFileIcon(doc.mimeType) }}
                        </mat-icon>
                        <span matListItemTitle>{{ doc.fileName }}</span>
                        <span matListItemLine>
                            {{ formatFileSize(doc.size) }} |
                            {{ doc.uploadDate | date: 'short' }}
                        </span>
                        <div matListItemMeta class="d-flex gap-1">
                            <button
                                mat-icon-button
                                (click)="downloadDocument(doc)">
                                <mat-icon fontSet="material-symbols-outlined"
                                    >download</mat-icon
                                >
                            </button>
                            @if (!disabled) {
                                <button
                                    mat-icon-button
                                    (click)="deleteDocument(doc)">
                                    <mat-icon fontSet="material-symbols-outlined"
                                        >delete</mat-icon
                                    >
                                </button>
                            }
                        </div>
                    </mat-list-item>
                }
            </mat-list>
        } @else if (!loading) {
            <p class="no-documents mt-2">
                {{ 'ECMR.ecmr_editor.documents.no_documents' | translate }}
            </p>
        }
    </mat-card-content>
</mat-card>
